import { useEffect, useState } from "react";
import { Loader2, Pencil } from "lucide-react";
import { api } from "@/lib/api";
import { friendlyDate } from "@/lib/format";
import { eventLabel } from "./EventButton";
import { EditItemForm } from "./EditItemForm";


const PENDING = new Set(["pending", "processing"]);

const Field = ({ label, children, testid }) => (
  <div className="info-field">
    <div className="info-label">{label}</div>
    <div className="info-value" data-testid={testid}>{children}</div>
  </div>
);

export const InfoPanel = ({ item, onUpdated }) => {
  const [editing, setEditing] = useState(false);
  const pending = item.status !== "done" || PENDING.has(item.ai_status);

  useEffect(() => setEditing(false), [item.id]);
  useEffect(() => {
    if (!pending) return undefined;
    const t = setInterval(async () => {
      const { data } = await api.get(`/items/${item.id}`);
      if (data.status === "done" && !PENDING.has(data.ai_status)) onUpdated(data);
    }, 4000);
    return () => clearInterval(t);
  }, [item.id, pending, onUpdated]);

  if (editing) return <EditItemForm item={item} onCancel={() => setEditing(false)} onSaved={(d) => { onUpdated(d, true); setEditing(false); }} />;

  return (
    <div className="info-panel-inner" data-testid="lightbox-details-panel">
      {item.can_delete && (
        <button className="info-edit" onClick={() => setEditing(true)} aria-label="Edit details" data-testid="lightbox-edit-button">
          <Pencil size={14} />
        </button>
      )}
      <Field label="Date" testid="lightbox-detail-date">{item.date_unknown ? "Date unknown" : friendlyDate(item.taken_at_local)}</Field>
      <Field label="Description" testid="lightbox-detail-description">
        {item.description ? (
          <p className="info-desc">{item.description}</p>
        ) : pending ? (
          <span className="info-muted"><Loader2 size={12} className="animate-spin inline mr-1" />Generating description…</span>
        ) : (
          <span className="info-muted">No description</span>
        )}
      </Field>
      {(item.event || item.event_category) && <Field label="Event" testid="lightbox-detail-event">{eventLabel(item)}</Field>}
    </div>
  );
};
